import { Badge } from '@sandtech-hub-monorepo/ui-kit';

import { StripeSubscriptionsQueryRow } from '../../../data/useStripeSubscriptions';
import { StatusTone, describeSubscription } from './subscriptionStatus';

/**
 * The Payments tab beside this one already badges its statuses, so these use
 * the same component and the same variants rather than a second pill style at
 * a slightly different opacity.
 */
const TONE_VARIANT: Record<StatusTone, 'success' | 'warning' | 'outline'> = {
  good: 'success',
  attention: 'warning',
  ended: 'outline',
};

interface Props {
  subscription: StripeSubscriptionsQueryRow;
}

export const SubscriptionCard = ({ subscription }: Props) => {
  const { headline, detail, tone } = describeSubscription(subscription);

  return (
    <div className="flex flex-col gap-2 rounded-2xl border border-border-secondary bg-card p-6">
      <div className="flex flex-wrap items-center gap-3">
        <h3 className="font-semibold text-heading">{subscription.plan.name}</h3>
        <Badge
          variant={TONE_VARIANT[tone]}
          className="rounded-full px-3 py-1 text-xs font-medium"
        >
          {headline}
        </Badge>
      </div>
      <p className="text-sm text-muted-foreground">{detail}</p>
    </div>
  );
};
